module.exports = __webpack_public_path__ + "logo_long.c650aa78c7cc104f75b254702b9000e0.png";